import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    const allFilter = {
                    items: [
                        ...(filterModel?.items || []),
                        ...[{
                            'field': 'action',
                            'operator': '!=',
                            'value': "start"
                        }]
                    ]
                };

    const chargeFilter = {
                    items: [
                        ...(filterModel?.items || []),
                        ...[{
                            'field': 'action',
                            'operator': 'in',
                            'value': ["charge", "charge_for_takeover"]
                        }]
                    ]
                };

    const dischargeFilter = {
                    items: [
                        ...(filterModel?.items || []),
                        ...[{
                            'field': 'action',
                            'operator': 'in',
                            'value': ["discharge_area_change", "discharge_end_of_employment", "discharge_end_of_agreement", "discharge_acceptance"]
                        }]
                    ]
                };

    const rebateFilter = {
                    items: [
                        ...(filterModel?.items || []),
                        ...[{
                            'field': 'action',
                            'operator': 'equals',
                            'value': "rebate"
                        }]
                    ]
                };

    return (drawable &&
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Listing value"
                dataProviderName={'statisticsviews/item/sumfinancial/opportunities/listing/value'}
                filters={allFilter}
                compareFilters={getComparableTimeframe(allFilter, 'registered_at')}
                comparePositiveCondition={'straight'}
                format='currency'
                compactformat={false}
            />
            <KPI
                title="Properties listed"
                dataProviderName={'statisticsviews/item/sum/opportunities/listing/quantity'}
                filters={filterModel}
                compareFilters={getComparableTimeframe(filterModel, 'registered_at')}
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Listing rows"
                dataProviderName={'statisticsviews/item/count/opportunities/listing'}
                filters={allFilter}
                compareFilters={getComparableTimeframe(allFilter, 'registered_at')}
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Carichi"
                dataProviderName={'statisticsviews/item/count/opportunities/listing'}
                filters={chargeFilter}
                compareFilters={getComparableTimeframe(chargeFilter, 'registered_at')}
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Scarichi"
                dataProviderName={'statisticsviews/item/count/opportunities/listing'}
                filters={dischargeFilter}
                compareFilters={getComparableTimeframe(dischargeFilter, 'registered_at')}
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Ribassi"
                dataProviderName={'statisticsviews/item/count/opportunities/listing'}
                filters={rebateFilter}
                compareFilters={getComparableTimeframe(rebateFilter, 'registered_at')}
                comparePositiveCondition={'straight'}
            />
        </Box>
    )
}

export default KPISet;